import React, { useState, useContext, useEffect, useLayoutEffect } from 'react'
import { Context } from './Context'
import axios from 'axios'
import { ContactData, QuoteData } from '../wbstdt/Wbstdt'
import Nav from './Nav'
import Footer from './Footer'
import LoadingScreen from './LoadingScreen'
import MessageDelivery from './MessageDelivery'

export default function Contact() {

    const { lang } = useContext(Context)
    const [code, setCode] = useState(QuoteData[lang].tab4[0].code)
    const [country, setCountry] = useState(QuoteData[lang].tab4[0].country)
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [number, setNumber] = useState('')
    const [subject, setSubject] = useState('')
    const [message, setMessage] = useState('')
    const [isFormEmpty, setIsFormEmpty] = useState(true)
    const [isLoading, setIsloading] = useState(false)
    const [msgDlShown, setMsgDlShown] = useState("")

    useEffect(() => {

        if (!name || !email || !subject || !message || !number)
            setIsFormEmpty(true)
        else
            setIsFormEmpty(false)
    }, [name, email, subject, message, number, lang])

    useLayoutEffect(() => {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
    }, [])

    const setRegion = (e) => {
        let countryCode = QuoteData[lang].tab4.filter(item => item.country === e.target.value)
        setCountry(countryCode[0].country)
        setCode(countryCode[0].code)
    }

    const sendEmail = (e) => {
        e.preventDefault()
        let messageBody = {
            name,
            email,
            country,
            number: `${code} ${number}`,
            subject,
            message
        }
        setIsloading(true)
        axios.post('/sending-email', {messageBody})
        .then(data => {
            setIsloading(false)
            setName("")
            setEmail("")
            setNumber("")
            setSubject("")
            setMessage("")
            setMsgDlShown("ss")
            setTimeout(() => {
                setMsgDlShown("")
            }, 3000);
        })
        .catch(err => {
            setIsloading(false)
            setMsgDlShown("ss")
            setTimeout(() => {
                setMsgDlShown("fl")
            }, 3000);
            console.log(err)
        })
    }

    return (
        <div id="contact-page">
            {isLoading && <LoadingScreen />}
            <Nav />
            <div className="cp-container flex-container-scattered box-wsp-outline flex-col">
                <div className="contact-desc">
                    <h2 className="title title-bullet">{ContactData[lang].title}</h2>
                    <p className="">{ContactData[lang].address}</p>
                    <div className="coords box-wsp">
                        {ContactData[lang].coords.map((item, index) => {
                            return (
                                <p key={index} data-title={item.title}>{item.desc}</p>
                            )
                        })}
                    </div>
                </div>
                <div className="contact-form">
                    <form onSubmit={sendEmail}>
                        <input type="text" className="if ifs-full " placeholder={ContactData[lang].form.tab1} value={name} onChange={(e) => setName(e.target.value)} required/>
                        <input type="email" className="if ifs-full" placeholder={ContactData[lang].form.tab2} value={email} onChange={(e) => setEmail(e.target.value)} required/>
                        <select className="if ifs-full" value={country} onChange={setRegion}>
                            {QuoteData[lang].tab4.map((item, index) => {
                                return (
                                    <option key={index} value={item.country}>{item.country}</option>
                                )
                            })}
                        </select>
                        <div className="tel-if tel-ifs-full">
                            <label htmlFor="tel">{code}</label>
                            <input type="tel" className="ifs-full" name="" id="tel" placeholder={ContactData[lang].form.tab3} value={number} onChange={(e) => setNumber(e.target.value)} pattern="^[+]*[0-9]{8,15}$" required/>
                        </div>
                        <input type="text" className="if ifs-full" placeholder={ContactData[lang].form.tab4} value={subject} onChange={(e) => setSubject(e.target.value)} required/>
                        <textarea type="text" className="if ifs-full txt-area" placeholder={ContactData[lang].form.tab5} value={message} onChange={(e) => setMessage(e.target.value)} required/>
                        <button className={`btn btn-full ${!isFormEmpty ? "btn-normal-enabled" : "btn-normal-disabled"}`} disabled={isFormEmpty}>{ContactData[lang].form.btn}</button>
                    </form>
                </div>
            </div>
            <Footer />
            {msgDlShown && <MessageDelivery msg={msgDlShown}/>}
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/Component/Contact.js